// extracted by mini-css-extract-plugin
export default {"mn-workbench":"index_mn-workbench__WoJQg"};